import { IMaskInput } from 'react-imask';

import { InputBase, InputBaseProps, Text, TextInputProps } from '@mantine/core';

import { useIcon } from '@/shared/hooks/useIcon';

import classes from './CarInput.module.css';

type TCarInputProps = {
	onChange: (carNumber: string) => void;
} & TextInputProps &
	InputBaseProps;

export const CarInput = ({ onChange, ...rest }: Omit<TCarInputProps, 'value'>) => {
	const icon = useIcon({ type: 'car', size: 24 });
	return (
		<InputBase
			classNames={classes}
			component={IMaskInput}
			mask={[
				{
					mask: '#000##000',
					definitions: {
						'#': /[ABEKMHOPCTYX]/i,
					},
				},
			]}
			placeholder="А000АА000"
			rightSection={icon}
			label={
				<Text c="#667085" fz={12} fw={500} lh="normal" tt="uppercase">
					Номер автомобиля
				</Text>
			}
			size="md"
			onAccept={onChange}
			{...rest}
		/>
	);
};
